"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cocquio-trevisago": {
    "e9c0b68a": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "bivacco": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ad286f19": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "bone": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9f9d7e88": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-laghetti": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "23e5d787": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-stoppada": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d7beb9ba": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "carnisio": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2cb4e0d8": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "cerro": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6ec72c5c": [{
      "hkey": "fd630524",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cocquio": [{
      "hkey": "fd630524",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7d30c984": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "intello": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "55b5fb5b": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "la-rocca": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4a28f302": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "monte-morto": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ab38d159": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "mulini": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7433873f": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "pra-camaree": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "66824247": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "roncaccio": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "44c3e276": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "ronco": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "915a1433": [{
      "hkey": "fd630524",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "fd630524",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cocquio-trevisago"
    }],
    "9a7e2011": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "sass-gross": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a1f49276": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "skipSearch": false
    }],
    "torre": [{
      "hkey": "efc35c84",
      "slug": "cocquio-trevisago",
      "name": "Cocquio-Trevisago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "07d0d457": [{
      "hkey": "fd630524",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "trevisago": [{
      "hkey": "fd630524",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cocquio-trevisago"
    }]
  }
};
exports["default"] = _default;